import { COMPLIANCE } from "@/data/content";
import { ShieldCheck } from "@phosphor-icons/react";

export const Compliance = () => {
  return (
    <section id="compliance" data-testid="compliance-section" className="relative py-24 lg:py-32 bg-[#0F172A] grain overflow-hidden">
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 mb-5">
            <ShieldCheck weight="fill" className="h-5 w-5 text-[#F87171]" />
            <span className="overline text-slate-400">Compliance &amp; Ethics</span>
          </div>
          <h2 className="font-serif-display text-3xl lg:text-4xl font-bold tracking-tight text-white">
            Recovery that regulators respect
          </h2>
          <p className="mt-5 text-slate-300 leading-relaxed">
            Every account is worked under strict regulatory frameworks. Our compliance stack protects your
            institution from reputational and legal exposure.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10">
          {COMPLIANCE.map((c) => (
            <div key={c.code} data-testid={`compliance-${c.code}`} className="border-r border-b border-white/10 p-8">
              <span className="font-mono-plex text-xs text-[#F87171]">{c.code}</span>
              <h3 className="mt-4 text-lg font-semibold text-white">{c.title}</h3>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
